import { InventoryAdjustment, productTransfer, TransferBeteweenWarehouse } from "interfaces";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface InvAdjustmentStoreProps {
  // * Properties
  payloadTransfer: InventoryAdjustment;
  productsTransfer: productTransfer[];

  // * Methods
  setPayloadTransfer: (payload: InventoryAdjustment) => void;
  addProductTransfer: (payload: productTransfer) => void;
  removeProductTransfer: (payload: number) => void;

  clearAllStore: () => void;
}

export const useInvAdjustmentStore = create<InvAdjustmentStoreProps>()(
  devtools((set) => ({
    // * Properties
    payloadTransfer: {
      warehouseId: 0,
      observation: "",
      transferDate: "",
      type:"",
    },
    productsTransfer: [],

    // * Methods
    setPayloadTransfer: (payload) =>
      set((state) => ({ payloadTransfer: payload })),
    addProductTransfer: (payload) =>
      set((state) => ({
        productsTransfer: [...state.productsTransfer, payload],
      })),

    removeProductTransfer: (payload) => {
      set((state) => ({
        productsTransfer: state.productsTransfer.filter(
          (product) => product.product_id !== payload
        ),
      }));
    },

    clearAllStore: () =>
      set(() => ({
        payloadTransfer: {
          warehouseId: 0,
          observation: "",
          type: '',
          transferDate: new Date().toISOString().split("T")[0],
        },
        productsTransfer: [],
      })),
  }))
);
